export default __webpack_public_path__ + "static/media/salary.fed1cc0f.png";